import ProviderManager from 'app/provider/providerManager';
import type {OrdersListResult} from 'app/Components/Page/SimActivationPage/SimActivationContext';
import {getRecaptchaToken} from '../../../utilities/recaptcha/recaptcha';

type createOtpProps = {
  phoneNumber: string;
  sendTextAsVoice: boolean;
  captchaToken: string;
};

export async function createOtp({phoneNumber, sendTextAsVoice, captchaToken}: createOtpProps) {
  try {
    const result = await ProviderManager.getProviderData('createOtp', [phoneNumber, sendTextAsVoice, captchaToken]);
    return result.Body && result.Body.step1Ticket ? result.Body.step1Ticket : null;
  } catch (error) {
    console.info('createOtp', error);
    return null;
  }
}

type validateOtpProps = {
  phoneNumber: string;
  ticket: string;
  otpCode: string;
};

export async function validateOtp({phoneNumber, ticket, otpCode}: validateOtpProps) {
  try {
    const result = await ProviderManager.getProviderData('validateOtp', [phoneNumber, ticket, otpCode]);
    return result.Header.ReturnCode == 0;
  } catch (error) {
    console.info('validateOtp', error);
    return false;
  }
}

export async function checkNiudCodeRequirement(phoneNumber: string) {
  try {
    var captchaToken = await getRecaptchaToken('checkNiudCodeRequirement');
    const result = await ProviderManager.getProviderData('CheckNiudCodeRequirement', [captchaToken, phoneNumber]);
    if (result.Header.ReturnCode == 0) return result.Body.isNiudCodeRequired;
  } catch (error) {
    console.info('CheckNiudCodeRequirement', error);
    return false;
  }
}

type getOrdersListProps = {
  subscriberNumber: string;
  ticketId: string;
  verificationCode: string;
};

export async function getOrdersList({subscriberNumber, ticketId, verificationCode}: getOrdersListProps) {
  try {
    const result = await ProviderManager.getProviderData('getOrdersList', [subscriberNumber, ticketId, verificationCode]);
    return result.Header.ReturnCode != 0 ? null : ((Array.isArray(result.Body) ? result.Body[0] : result.Body) as OrdersListResult);
  } catch (error) {
    console.info('getOrdersList', error);
    return null;
  }
}

export async function requestActivate({subscriberNumber, ticketId, verificationCode}: getOrdersListProps) {
  try {
    const result = await ProviderManager.getProviderData('requestActivate', {subscriberNumber, ticketId, verificationCode});
    return !!result.Body?.success;
  } catch (error) {
    console.info('requestActivate', error);
    return false;
  }
}
